(function () {
  const root = document.querySelector('[data-bc-kit-sol]');
  if (!root) return;

  const variants = JSON.parse(root.querySelector('[data-bc-kit-variants]')?.textContent || '[]');
  const moneyFormat = root.dataset.moneyFormat || '{{amount}} €';
  const checkoutUrl = root.dataset.checkoutUrl || '/checkout';
  const cartRoot = window.Shopify?.routes?.root || '/';

  const finishLabels = {
    mineral: 'Béton Ciré Minéral',
    coule: 'Finition Béton Coulé',
  };

  const surfaceMap = { 5: 'Petite', 10: 'Petite', 20: 'Moyenne', 40: 'Grande', 50: 'Grande' };

  const els = {
    finish: root.querySelectorAll('[data-bc-kit-finish]'),
    surface: root.querySelectorAll('[data-bc-kit-surface]'),
    support: root.querySelectorAll('[data-bc-kit-support]'),
    colorPanels: root.querySelectorAll('[data-bc-kit-colors-panel]'),
    prepNote: root.querySelector('[data-bc-kit-prep-note]'),
    surfaceLabel: root.querySelector('[data-bc-kit-surface-label]'),
    colorLabel: root.querySelector('[data-bc-kit-color-label]'),
    price: root.querySelector('[data-bc-kit-price]'),
    form: root.querySelector('[data-bc-kit-form]'),
    variantInput: root.querySelector('[data-bc-kit-variant-id]'),
    propFinish: root.querySelector('[data-bc-kit-prop-finish]'),
    propSurface: root.querySelector('[data-bc-kit-prop-surface]'),
    propSupport: root.querySelector('[data-bc-kit-prop-support]'),
    propColor: root.querySelector('[data-bc-kit-prop-color]'),
    submit: root.querySelector('[data-bc-kit-submit]'),
    checkout: root.querySelector('[data-bc-kit-checkout]'),
    heroImg: root.querySelector('[data-bc-kit-hero-img]'),
  };

  let state = {
    finish: 'mineral',
    surface: 20,
    support: 'chape',
    color: '',
  };

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return moneyFormat.replace('{{amount}}', amount).replace('{{ amount }}', amount);
  }

  function getActiveColorPanel() {
    return root.querySelector('[data-bc-kit-colors-panel="' + state.finish + '"]');
  }

  function getColorButtons(panel) {
    return panel ? panel.querySelectorAll('[data-bc-kit-color]') : [];
  }

  function getActiveColorButton() {
    const panel = getActiveColorPanel();
    const buttons = getColorButtons(panel);
    return Array.from(buttons).find(function (btn) {
      return btn.dataset.colorLabel === state.color;
    });
  }

  function getSelectedVariant() {
    const surfaceKey = surfaceMap[state.surface];
    const finishKey = state.finish === 'mineral' ? 'Minérale' : 'Béton coulé';
    const systemKey = state.support === 'carrelage' ? 'Performance' : 'Standard';

    return variants.find(function (v) {
      return v.surface === surfaceKey && v.finition === finishKey && v.systeme === systemKey;
    });
  }

  function setActive(group, value, attr) {
    group.forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute(attr) === String(value));
    });
  }

  function updateHeroImage() {
    if (!els.heroImg) return;

    const activeBtn = getActiveColorButton();
    const nextSrc = activeBtn?.dataset.heroSrc || els.heroImg.dataset.defaultSrc || els.heroImg.src;

    if (!nextSrc || els.heroImg.dataset.currentSrc === nextSrc) return;

    els.heroImg.classList.add('is-swapping');

    window.setTimeout(function () {
      els.heroImg.src = nextSrc;
      els.heroImg.removeAttribute('srcset');
      els.heroImg.dataset.currentSrc = nextSrc;
      els.heroImg.classList.remove('is-swapping');
    }, 180);
  }

  function syncColorPanel() {
    els.colorPanels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-bc-kit-colors-panel') !== state.finish;
    });

    const panel = getActiveColorPanel();
    const buttons = getColorButtons(panel);
    let matched = false;

    buttons.forEach(function (btn) {
      const isActive = btn.dataset.colorLabel === state.color;
      btn.classList.toggle('is-active', isActive);
      if (isActive) matched = true;
    });

    if (!matched && buttons.length) {
      state.color = buttons[0].dataset.colorLabel || '';
      buttons[0].classList.add('is-active');
    }
  }

  function setButtonsLoading(isLoading) {
    [els.submit, els.checkout].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = isLoading || !getSelectedVariant() || !state.color;
      btn.classList.toggle('is-loading', isLoading);
      btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    });
  }

  function updateUI() {
    const variant = getSelectedVariant();

    setActive(els.finish, state.finish, 'data-bc-kit-finish');
    setActive(els.surface, state.surface, 'data-bc-kit-surface');
    setActive(els.support, state.support, 'data-bc-kit-support');
    syncColorPanel();

    if (els.prepNote) {
      els.prepNote.hidden = state.support !== 'carrelage';
    }

    if (els.surfaceLabel) {
      els.surfaceLabel.textContent = state.surface + ' m²';
    }

    if (els.colorLabel) {
      els.colorLabel.textContent = state.color || '—';
    }

    if (variant && els.price) {
      els.price.textContent = variant.price_formatted || formatMoney(variant.price);
    }

    if (variant && els.variantInput) {
      els.variantInput.value = variant.id;
    }

    if (els.propFinish) {
      els.propFinish.value = finishLabels[state.finish];
    }
    if (els.propSurface) {
      els.propSurface.value = state.surface + ' m²';
    }
    if (els.propSupport) {
      const supportEl = root.querySelector('[data-bc-kit-support="' + state.support + '"]');
      els.propSupport.value = supportEl ? supportEl.dataset.label : state.support;
    }
    if (els.propColor) {
      els.propColor.value = state.color;
    }

    setButtonsLoading(false);
    updateHeroImage();
  }

  async function addToCart(onSuccess) {
    const variant = getSelectedVariant();
    if (!variant || !state.color) return false;

    setButtonsLoading(true);
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const formData = new FormData();
    formData.set('id', variant.id);
    formData.set('quantity', '1');
    formData.set('properties[Finition]', finishLabels[state.finish]);
    formData.set('properties[Couleur]', state.color);
    formData.set('properties[Surface]', state.surface + ' m²');
    formData.set('properties[Support]', els.propSupport?.value || state.support);
    formData.set('properties[_kit_type]', 'sol-interieur');
    formData.set('sections', sectionsToBundle.join(','));
    formData.set('sections_url', cartRoot + 'variants/' + variant.id);

    try {
      const response = await fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson.description || 'Cart error');
      }

      const cartContent = await (await fetch(cartRoot + 'cart.js')).json();
      cartContent.sections = responseJson.sections;

      if (onSuccess === 'checkout') {
        window.location.href = checkoutUrl;
        return true;
      }

      if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
        window.location.href = root.dataset.cartUrl || cartRoot + 'cart';
        return true;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartContent,
          },
        })
      );

      return true;
    } catch (error) {
      alert(error.message || 'Impossible d\u2019ajouter le kit au panier. Veuillez r\u00e9essayer.');
      return false;
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      setButtonsLoading(false);
    }
  }

  els.finish.forEach(function (el) {
    el.addEventListener('click', function () {
      state.finish = el.getAttribute('data-bc-kit-finish');
      state.color = '';
      updateUI();
    });
  });

  els.surface.forEach(function (el) {
    el.addEventListener('click', function () {
      state.surface = parseInt(el.getAttribute('data-bc-kit-surface'), 10);
      updateUI();
    });
  });

  els.support.forEach(function (el) {
    el.addEventListener('click', function () {
      state.support = el.getAttribute('data-bc-kit-support');
      updateUI();
    });
  });

  root.querySelectorAll('[data-bc-kit-color]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (el.getAttribute('data-bc-kit-color') !== state.finish) return;
      state.color = el.dataset.colorLabel || '';
      updateUI();
    });
  });

  if (els.form) {
    els.form.addEventListener('submit', function (event) {
      event.preventDefault();
      addToCart('drawer');
    });
  }

  if (els.checkout) {
    els.checkout.addEventListener('click', function () {
      addToCart('checkout');
    });
  }

  const firstPanel = getActiveColorPanel();
  const firstColor = getColorButtons(firstPanel)[0];
  if (firstColor) {
    state.color = firstColor.dataset.colorLabel || '';
  }

  updateUI();
})();
